module fdm.performedLegs {

    export class PerformedLegsService {


        public constructor(
            private actionService: dg.actions.ActionService) {

        }
    }

    angular.module('fdm.performedLegs')
        .service('performedLegsService', PerformedLegsService);
}